// extracted by mini-css-extract-plugin
module.exports = {"root":"modal-icon-close_root__DDzvT"};